import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreloaderComponent implements OnInit {
  @Input() message: string = 'Loading data, please wait...';
  @Input() marginTop: string = '35vh';
  @Input() classes: string = '';
  
  constructor() { }

  ngOnInit() {
  }

}
